import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { API_URL_CONSULTATION_ADD } from "manager/http-constants";
import { API_RESPONSE } from "src/app/shared/constant/api-constant";
import { LOADING_KEY } from "src/app/shared/constant/constant";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { TOAST } from "src/app/shared/constant/primeng-constants";
import { LoadingState } from "src/app/shared/html-parts/loading/loading-state";
import {
  MessageData,
  ToastMessageData,
} from "src/app/shared/html-parts/message-common/message-data";
import { CommonService } from "src/app/shared/service/common.service";
import { DbOperationService } from "src/app/shared/service/db-operation.service";
import { PlatformComponent } from "../../platform.component";
import { LoginService } from "src/app/shared/service/login.service";

@Component({
  selector: "app-consultation-dialog",
  templateUrl: "./consultation-dialog.component.html",
  styleUrls: ["./consultation-dialog.component.scss"],
})
export class ConsultationDialogComponent extends PlatformComponent {
  @Input() id: string;
  @Output() returnConsultationDialog = new EventEmitter<boolean>();

  ConsultationDialogFlag: boolean = false;
  initConsultationContent: string = "";
  consultationInput: string = "";
  consultationInput2: string = "";
  match_id: string;
  consultation: any;
  mode: string = 'input';

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private messageData: MessageData,
    public loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);
  }

  ngOnInit(): void { }

  openConsultationDialog(match_id: string, consultation) {
    this.consultation = consultation;
    this.ConsultationDialogFlag = true;
    this.match_id = match_id;
    this.consultationInput = consultation.contente;
    this.consultationInput2 = consultation.contente_2;
    this.initConsultationContent = consultation.contente;
    if (consultation.type == 'detail_c502') {
      this.mode = 'detail_c502'
    } else if (this.initConsultationContent !== '') {
      this.mode = 'detail'
    } else {
      this.mode = 'input'
    }
  }

  addConsultation() {
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);
    if (this.consultationInput.trim() == "" && this.initConsultationContent.trim() == "") {
      this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);
      this.closeConsultationDialog();
      return;
    }
    this.dbOperationService
      .insertData(API_URL_CONSULTATION_ADD, { contente: this.consultationInput.trim(), match_id: this.match_id, consult_status: 1 })
      .subscribe((response) => {
        this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

        // レスポンス結果を判定
        if (API_RESPONSE.SUCCESS == response.body.Message) {
          this.returnConsultationDialog.emit(true);

          // 正常メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.SUCCESS,
              summary: this.commonService.msg(MESSAGE_CODE.T00002),
            })
          );
          this.closeConsultationDialog();
        } else if (this.commonService.checkInvalidValue(response)) {
          // 警告メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );
          this.returnConsultationDialog.emit(true);
          this.closeConsultationDialog();
        } else {
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
            })
          );
        }
      });
  }

  public closeConsultationDialog(): void {
    this.ConsultationDialogFlag = false;
  }
  public confirm(): void {
    this.mode = 'confirm';
  }
  public cancelConfirm(): void {
    this.mode = 'input';
  }
  isDisabledConsultation() {
    return this.consultationInput.trim() == "";
    // return ((this.initConsultationContent.trim() == "" && this.consultationInput.trim() == "") ||  this.initConsultationContent.trim() == this.consultationInput.trim() || this.consultationInput.trim() == "")
  }

  getConsultationInput() {
    return this.consultationInput.split("\n");
  }
}
